import type { FunctionComponent } from "react";

import { Container, Label, StyledIconScmpFlag } from "./styles";

type Props = {
  className?: string;
};

export const ExclusiveFlag: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <StyledIconScmpFlag />
    <Label>Exclusive</Label>
  </Container>
);

ExclusiveFlag.displayName = "ExclusiveFlag";
